// extracted by mini-css-extract-plugin
export default {"root":"textarea_root__6EJPm","adaptive":"textarea_adaptive__NFhsK"};